import { hasCapability, type User } from "../base";

export const link = {
  create: (user: User) => hasCapability(user, "link.create"),
};
